export enum SD_Services {
  LMS_Service = 'lmsService',
  Client_App = 'clientApp',
  MessageService = 'messageService',
  ResellerService = 'resellerService',
  MCQTestService = 'mcqTest',
  Profile = 'profile',
}

export enum SD_Applications {
  Browser = 'browser',
  Windows = 'windows',
  Android = 'android',
  Mac = 'mac',
  Ios = 'ios',
}

export enum SD_SPNameList {
  DB_SP_Term = 'sptblterm',
  DB_SP_InternalServicesType = 'spInternalServicesType',
  DB_SP_Course = 'sptblCourse',
  DB_SP_CourseDetails = 'sptblCourseDetails',
  DB_SP_Package = 'sptblPackage',
  DB_SP_PackageDetails = 'sptblPackageDetails',
  DB_SP_CommonServices = 'spCommonServices',
  DB_SP_WhatsApp = 'sptblWhatsApp',
  DB_SP_WhatsAppDetails = 'sptblWhatsAppDetails',
  DB_SP_InternelWhatsAppResponse = 'spTblInternelWhatsAppResponse',
  DB_SP_WhatsAppTree = 'sptblWhatsAppTree',
  DB_SP_SpInternalServicesType = 'spInternalServicesType',
  DB_SP_spTblEncryptionHistory = 'sptblEncryptionHistory',
  DB_SP_spTblVideoDetails = 'spTblVideoDetails',
  DB_SP_MasterMCQ = 'SPTblMasterMCQ',
  DB_SP_DocumentDetails = 'spTblDocumentDetails',
  DB_SP_EncryptedUnassigned = 'sptblEncryptedUnassigned',
  DB_SP_Faculties = 'sptblFacultiesMaster',
  DB_SP_TblPackageFaculty = 'sptblPackageFaculty',
  DB_SP_TblActivationKeyPermission = 'sptblActivationKeyPermission',
  DB_SP_TblActivationKeys = 'sptblActivationKeys',
  DB_SP_TblPackageCombo = 'sptblPackageCombo',
  DB_SP_TblMasterSectionChapters = 'sptblMasterSectionChapter',
  DB_SP_TblContent = 'spTblContent',
  DB_SP_TblLibraryLink = 'spTblLibraryLink',
  DB_SP_TblPage = 'spTblPage',
  DB_SP_TblSection = 'spTblSection',
  DB_SP_TblTemplate = 'spTblTemplate',
  DB_SP_TblTheoryExamSet = 'sptblTheoryExamSet',
  DB_SP_TblTheoryCheckerPermission = 'sptblTheoryCheckerPermission',
  DB_SP_TblClientRoutes = 'SPClientRoutes',
  DB_SP_TblBookRoutes = 'sptblBook',
  DB_SP_TblSettingFranchise = 'sptblSettingsFranchise',
  DB_SP_StudentActivation = 'spStudentActivation',
  DB_SP_ClientApiConfiguration = 'spClientApiConfiguration',
  DB_SP_Dashboard = 'spDashboard',
  DB_SP_Backup = 'sptblVideoBackup',
  DB_SP_TblPodcast = 'spTblPodcast',
  DB_SP_TblPackagePdf = 'sptblPackagePdf',
  DB_SP_EmailTemplate = 'spEmailTemplate',
  DB_SP_LayoutStore = 'SPTblLayoutStore',
  DB_SP_TemplateCourseDetails = 'sptblTemplateCourseDetails',
  DB_SP_ExamTheoryDetails = 'sptblTheoryExamSet',
  DB_SP_CourseBuilder = 'spCourseBuilder',
  DB_SP_UserProfile = 'spUserProfile',
  DB_SP_AppBanner = 'sptblAppBanner',
  DB_SP_QuestionAnswers = 'sptblQuestionAnswer',
  DB_SP_FranchisePlayer = 'sptblFranchisePlayer',
  DB_SP_Notification = 'sptblNotification',
  DB_SP_NotificationList = 'SpTblNotificationlist',
  DB_SP_Courier = 'spCourier',
  DB_SP_BulkImport = 'sptblBulkStudentImport',
  DB_SP_TblMasterMCQTest = 'spTblMasterMCQTest',
  DB_SP_Form = 'sptblFormMaster',
  DB_SP_Storage = 'spStorage',
  DB_SP_Report = 'spReport',
  DB_SP_Vendor = 'sptblVendorManagement',
  DB_SP_Device = 'spDeviceChange',
  DB_SP_McqSeries = 'spTblMasterMCQTest',
  DB_SP_MCQQuestion = 'spTblMasterMCQQuestion',
  DB_SP_PackagePrice = 'sptblPackagePrice',
  DB_SP_MessageService = 'SPMessageService',
  DB_SP_AppStore = 'sptblAppStore',
  DB_SP_MasterIP = 'sptblMasterIP',
  DB_SP_Origin = 'spTblMasterOrigin',
  DB_SP_MasterUserAgent = 'spTblMasterUserAgent',
  DB_SP_WebsiteVideo = 'sptblDemo',
  DB_SP_MasterAdminAnonymous = 'SPMasterAdminAnonymous',
  DB_SP_TheoryExamAnswer = 'sptblTheoryExamAnswer',
  DB_SP_SocialMedia = 'sptblSocialMediaLinks',
  DB_SP_MCQResult = 'spTblMasterMCQResult',
  DB_SP_ClientAcceptLayout = 'SPClientAcceptLayout',
  DB_SP_TblFileDocs = 'SPTblFileDocs',
  DB_SP_TblLivePageMetaTags = 'SPTblLivePageMetaTags',
  DB_SP_TblClientUploadedContent = 'SPTblClientUploadedContent',
  DB_SP_TblReseller = 'spReseller',
  DB_SP_TblResellerCoupon = 'spResellerCoupon',
  DB_SP_TblResellerTransaction = 'spResellerTransaction',
  DB_SP_TblResellerCommission = 'spResellerCommission',
  DB_SP_TblStudentManagement = 'spStudentManagement',
  DB_SP_Faq = 'sptblFaq',
  DB_SP_StudentAttendance = 'sptblStudentAttendance',
  DB_SP_StudentAdmission = 'spStudentAdmission',
  DB_SP_PlayerDownload = 'sptblPlayerDownload',
  DB_SP_FranchiseExternalLogins = 'spTblFranchiseExternalLogins',
  DB_SP_TblCoupon = 'spTblCoupon',
  DB_SP_LivePoll = 'spLivePoll',
  DB_SP_Community_Forum = 'spCommunityForum',
  DB_SP_EmailGroup = 'sptblEmailGroup',
  DB_SP_PaymentService = 'spWebApiPaymentCommon',
  DB_SP_TblBackupVideos = 'spTblBackupVideo',
  DB_SP_BlackWhiteList = 'spBlackWhiteList',
  DB_SP_TblPackageDuplicate = 'sptblPackageDuplicate',
  DB_SP_TblAppStore2 = 'sptblAppStore2',
  DB_SP_WebApiPaymentCommon = 'spWebApiPaymentCommon',
  DB_SP_FranchiseOtherDetails = 'spFranchiseOtherDetails',
  DB_SP_BulkStudentActivation = 'SpBulkStudentActivation',
  DB_SP_SalesDashboard = 'SPSalesDashboard',
  DB_SP_MasterFranchise = 'SPMasterFranchise',
  DB_SP_FreeResource = 'SPFreeResource',
  DB_SP_AppVersion = 'spAppUpdate',
  DB_SP_Invoice = 'spInvoice',
  DB_SP_Communities_Panel = 'spCommunities_Panel',
  DB_SP_Client_internal_service = 'spInternalService',
  DB_SP_SPBlog = 'SPBlog',
  DB_SP_SPBlogTemplate = 'SPBlogTemplate',
  DB_SP_UserChangeRecord = 'spUserChangeRecord',
  DB_SP_ResellerPackage = 'spResellerPackage',
  DB_SP_ResellerPackagePrice = 'spResellerPackagePrice',
  DB_SP_ResellerStudentActivation = 'spResellerStudentActivation',
  DB_SP_AccessTokens = 'spAccessTokens',
}

export enum SD_InputStruct {
  inputText = 'inputText',
  inputNumber = 'inputNumber',
  inputBoolean = 'inputBoolean',
  inputArray = 'inputArray',
  inputSelect = 'inputSelect',
}

export enum SD_Category {
  Structure = 'Structure',
  Attribute = 'Attribute',
  Pricing = 'Pricing',
  Details = 'Details',
}

export enum SD_DynamicFormElement {
  PDF = 'PDF',
  IMAGE = 'IMAGE',
  LINK = 'LINK',
  PLAIN_TEXT = 'PLAIN TEXT',
  FORMATTED_TEXT = 'FORMATTED TEXT',
  VIDEO_URL = 'VIDEO URL',
  ZIP_RAR = 'ZIP RAR',
  Video = 'Video',
  IFRAME = 'IFRAME',
  OTHERS = 'OTHERS',
}

export enum SD_MonacoEditor {
  HTML = 'html',
  CSS = 'css',
  JS = 'javascript',
}

export enum SD_UserConfirmationType {
  PhoneNumberConfirmed = 1,
  EmailConfirmed = 2,
  //PhoneNumberAndEmailBothConfirmed = 3,
  //PhoneNumberOrEmailConfirmed = 4,
  WhatsAppNumberConfirmed = 5,
  //WhatsAppNumberAndEmailConfirmed = 6,
  WhatsAppNumberOrEmailConfirmed = 7,
}

export enum SD_AccessLocalStorage {
  DashboardMenuOrder = 'dashboardMenuOrder',
}

export enum SD_LoginProvider {
  Google = 'google',
  Facebook = 'facebook',
  LinkedIn = 'linkedin',
  Apple = 'apple',
  Twitter = 'twitter',
  WhatsApp = 'whatsapp',
  Mobile = 'mobile',
  Email = 'email',
}

export enum SD_PaymentServices {
  RazorPay = '1',
  ATOMS = '2',
  CashFree = '3',
  Hdfc = '4',
  Easebuzz = '5',
  Paytm = '6',
}
